// Navegação V1 → V2 da área logada e retorno pós-login (pedido do Eduardo, 16/10/2026).
// O mapa /admin → V2 segue os destinos do menu V2 (V2AccountLayout) e do
// orderDetailPath (adminPath.js): pedidos e atendimento da "conta" vivem em
// /v2/conta/*; o resto da administração, no espelho /v2/admin/* — inclusive
// edit/:id, que no V1 também é a edição de OUTRO usuário (relatório de usuários,
// que no espelho já aponta para /v2/admin/edit/:id).

export const V2_LOGIN_PATH = '/v2/conta/entrar'

// /admin/<rest> → caminho V2 equivalente, preservando search e hash.
// /admin puro devolve null: o destino depende do perfil (ver v2LandingFor).
// Sem distinção de maiúsculas, como o casamento de rotas do react-router.
export function v2PathFromAdmin(pathname, search = '', hash = '') {
  const match = /^\/admin(?:\/(.*))?$/i.exec(pathname || '')
  if (!match) return null
  const rest = (match[1] || '').replace(/\/{2,}/g, '/').replace(/^\/|\/$/g, '')
  if (!rest) return null

  const lower = rest.toLowerCase()
  let target
  let parts
  if (lower === 'pedidos') target = '/v2/conta/pedidos'
  else if ((parts = /^pedidos\/([^/]+)$/i.exec(rest))) target = `/v2/conta/pedidos/${parts[1]}`
  else if (lower === 'atendimento') target = '/v2/conta/atendimento'
  else target = `/v2/admin/${rest}`

  return target + (search || '') + (hash || '')
}

// Destino pós-login aceito em ?redirect_to= — só caminho relativo do próprio site,
// dentro do V2 e que não seja a própria tela de login (evita open redirect e loop).
export function safeRedirectTo(value) {
  if (typeof value !== 'string' || !value.startsWith('/v2/')) return null
  // caracteres de controle (tab/quebra de linha são descartados na URL)
  if (/[\u0000-\u001f\u007f]/.test(value)) return null // eslint-disable-line no-control-regex
  const path = value.split(/[?#]/)[0]
  // no caminho: '//' (protocol-relative), '\' (o navegador trata como '/') e
  // segmentos '.'/'..' (inclusive %2e), que o roteador resolveria para fora do /v2
  if (path.includes('//') || path.includes('\\') || /%2e/i.test(path) || /(^|\/)\.{1,2}(\/|$)/.test(path)) return null
  if (path.replace(/\/+$/, '').toLowerCase() === V2_LOGIN_PATH) return null
  return value
}

// Tela de login V2 levando o destino original em ?redirect_to=
export const loginPathFor = (pathname, search = '', hash = '') =>
  `${V2_LOGIN_PATH}?redirect_to=${encodeURIComponent(pathname + (search || '') + (hash || ''))}`

// Página inicial da área logada V2 por perfil — regra do /admin puro do V1
// (perfil >= 2 → dashboard; comprador → pedidos). Sem perfil carregado, onde o V1
// não redirecionava, vai para os pedidos (a tela comum a todos os perfis).
export function v2LandingFor(user) {
  const role = user && user.roles && user.roles[0]
  return role && role.id >= 2 ? '/v2/admin/dashboard' : '/v2/conta/pedidos'
}
